import { COMMISSIONS_POLICIES_SELECT_INCENTIVE } from '../constants'

export function reducer(state, action) {
  if (action.type === COMMISSIONS_POLICIES_SELECT_INCENTIVE) {
      return {
        ...state,
        policies: {
          ...state.policies,
          listIncentives: action.data
        }
      }
  }
  else {
    return state
  }
}
